/* ET - Info Image Tabs — hotspot badge tooltips (one open at a time, edge-aware) */
(function () {
  'use strict';

  // The section emits one script tag per instance; only the first should bind.
  if (window.etInfoImageTabsLoaded) return;
  window.etInfoImageTabsLoaded = true;

  var ROOT_SELECTOR = '[data-et-info-image-tabs]';
  var HOTSPOT_SELECTOR = '.et-info-image-tabs__hotspot';
  var BADGE_SELECTOR = '.et-info-image-tabs__badge';
  var TOOLTIP_SELECTOR = '.et-info-image-tabs__tooltip';
  var MEDIA_SELECTOR = '.et-info-image-tabs__media';
  var STAGE_SELECTOR = '[data-et-iit-stage]';
  var IMAGE_SELECTOR = '.et-info-image-tabs__image';
  var CROPPED_CLASS = 'is-cropped';
  var OPEN_CLASS = 'is-open';
  var FLIP_LEFT = 'et-info-image-tabs__hotspot--flip-left';
  var FLIP_RIGHT = 'et-info-image-tabs__hotspot--flip-right';
  var FLIP_DOWN = 'et-info-image-tabs__hotspot--flip-down';
  var EDGE_PADDING = 8;

  function roots(scope) {
    return (scope || document).querySelectorAll(ROOT_SELECTOR);
  }

  function hotspots(root) {
    return root.querySelectorAll(HOTSPOT_SELECTOR);
  }

  function badgeOf(hotspot) {
    return hotspot.querySelector(BADGE_SELECTOR);
  }

  function tooltipOf(hotspot) {
    return hotspot.querySelector(TOOLTIP_SELECTOR);
  }

  function isOpen(hotspot) {
    return hotspot.classList.contains(OPEN_CLASS);
  }

  function close(hotspot) {
    if (!hotspot || !isOpen(hotspot)) return;

    hotspot.classList.remove(OPEN_CLASS, FLIP_LEFT, FLIP_RIGHT, FLIP_DOWN);

    var badge = badgeOf(hotspot);
    var tooltip = tooltipOf(hotspot);
    if (badge) badge.setAttribute('aria-expanded', 'false');
    if (tooltip) tooltip.setAttribute('aria-hidden', 'true');
  }

  function closeAllIn(root, except) {
    Array.prototype.forEach.call(hotspots(root), function (hotspot) {
      if (hotspot !== except) close(hotspot);
    });
  }

  /* Re-anchor a tooltip that would spill past the media box. Measured only while the
     panel is open, so the rect is the real laid-out one rather than a hidden guess. */
  function place(root, hotspot) {
    var tooltip = tooltipOf(hotspot);
    var media = root.querySelector(MEDIA_SELECTOR);
    if (!tooltip || !media) return;

    hotspot.classList.remove(FLIP_LEFT, FLIP_RIGHT, FLIP_DOWN);

    /* Work out where the centred, upward panel would land from layout values, not from the
       tooltip's own rect: right after the flip classes come off, its transform is still mid
       transition, so a measured rect alternated between flipped and not on every resize.
       Unflipped, the panel is centred on the badge and sits 10px above it. */
    var bounds = media.getBoundingClientRect();
    var spot = hotspot.getBoundingClientRect();
    var centre = spot.left + spot.width / 2;
    var half = tooltip.offsetWidth / 2;
    var top = spot.top - 10 - tooltip.offsetHeight;

    if (centre + half > bounds.right - EDGE_PADDING) {
      hotspot.classList.add(FLIP_RIGHT);
    } else if (centre - half < bounds.left + EDGE_PADDING) {
      hotspot.classList.add(FLIP_LEFT);
    }

    /* The panel opens upward, so a badge near the top of the image would push it
       out of the section. Drop it below the badge instead. */
    if (top < bounds.top + EDGE_PADDING) {
      hotspot.classList.add(FLIP_DOWN);
    }
  }

  function open(root, hotspot) {
    closeAllIn(root, hotspot);

    hotspot.classList.add(OPEN_CLASS);

    var badge = badgeOf(hotspot);
    var tooltip = tooltipOf(hotspot);
    if (badge) badge.setAttribute('aria-expanded', 'true');
    if (tooltip) tooltip.setAttribute('aria-hidden', 'false');

    place(root, hotspot);
  }

  function toggle(root, hotspot) {
    if (isOpen(hotspot)) {
      close(hotspot);
    } else {
      open(root, hotspot);
    }
  }

  /* The photo is drawn with object-fit: cover, so only part of it shows, and which part changes with
     the band's size (screen width, card copy). Size the stage to the photo exactly as it is drawn -
     the same cover scale and the same object-position - so a hotspot's X/Y, a percentage of the
     stage, is a percentage of the PHOTO and the badge stays on its object at every width.
     A hotspot whose spot is cropped off at this width is hidden instead of hanging at the edge. */
  function fit(root) {
    var stage = root.querySelector(STAGE_SELECTOR);
    var media = root.querySelector(MEDIA_SELECTOR);
    if (!stage || !media) return;

    var ratio = parseFloat(stage.getAttribute('data-et-iit-ar'));
    var w = media.clientWidth;
    var h = media.clientHeight;
    if (!(ratio > 0) || !w || !h) return;

    var fx = 0.5;
    var fy = 0.5;
    var image = root.querySelector(IMAGE_SELECTOR);
    if (image) {
      var pos = (window.getComputedStyle(image).objectPosition || '').split(' ');
      if (pos[0] && pos[0].slice(-1) === '%') fx = parseFloat(pos[0]) / 100;
      if (pos[1] && pos[1].slice(-1) === '%') fy = parseFloat(pos[1]) / 100;
    }

    var sw = w;
    var sh = w / ratio;
    if (sh < h) {
      sh = h;
      sw = h * ratio;
    }
    var left = (w - sw) * fx;
    var top = (h - sh) * fy;

    stage.style.left = left + 'px';
    stage.style.top = top + 'px';
    stage.style.right = 'auto';
    stage.style.bottom = 'auto';
    stage.style.width = sw + 'px';
    stage.style.height = sh + 'px';

    /* offsetLeft/Top ignore the badge's translate(-50%, -50%), so they are its centre. */
    Array.prototype.forEach.call(hotspots(root), function (hotspot) {
      var x = left + hotspot.offsetLeft;
      var y = top + hotspot.offsetTop;
      hotspot.classList.toggle(CROPPED_CLASS, x < 0 || x > w || y < 0 || y > h);
    });
  }

  function observe(root) {
    if (root.etInfoImageTabsObserver) return;
    var media = root.querySelector(MEDIA_SELECTOR);
    if (!media || !root.querySelector(STAGE_SELECTOR)) return;
    if ('ResizeObserver' in window) {
      /* The band resizes with the screen and with the card's copy; both move the crop. */
      root.etInfoImageTabsObserver = new ResizeObserver(function () {
        fit(root);
        /* The badges moved with the stage, so an open tooltip's flip is decided again on the new positions. */
        Array.prototype.forEach.call(root.querySelectorAll(HOTSPOT_SELECTOR + '.' + OPEN_CLASS), function (hotspot) {
          place(root, hotspot);
        });
      });
      root.etInfoImageTabsObserver.observe(media);
    }
    fit(root);
  }

  function ancestor(node, selector) {
    var el = node && node.nodeType === 1 ? node : node && node.parentElement;
    /* SVG children are Elements too, but guard anyway for older engines. */
    return el && typeof el.closest === 'function' ? el.closest(selector) : null;
  }

  /* One delegated listener per section root — never document-wide — so several
     instances of the section on one page stay independent. */
  function init(scope) {
    Array.prototype.forEach.call(roots(scope), function (root) {
      observe(root);
      if (root.etInfoImageTabsBound) return;

      /* Kept on the node so destroy() can detach it — a re-init on a surviving
         root would otherwise double-bind and toggle twice per click. */
      var handler = function (event) {
        var badge = ancestor(event.target, BADGE_SELECTOR);
        if (!badge || !root.contains(badge)) return;

        var hotspot = badge.closest(HOTSPOT_SELECTOR);
        if (!hotspot) return;

        toggle(root, hotspot);
      };

      root.etInfoImageTabsBound = handler;
      root.addEventListener('click', handler);
    });
  }

  function destroy(scope) {
    Array.prototype.forEach.call(roots(scope), function (root) {
      Array.prototype.forEach.call(hotspots(root), close);
      if (root.etInfoImageTabsObserver) {
        root.etInfoImageTabsObserver.disconnect();
        root.etInfoImageTabsObserver = null;
      }
      if (root.etInfoImageTabsBound) {
        root.removeEventListener('click', root.etInfoImageTabsBound);
        root.etInfoImageTabsBound = null;
      }
    });
  }

  function openHotspots() {
    return document.querySelectorAll(ROOT_SELECTOR + ' ' + HOTSPOT_SELECTOR + '.' + OPEN_CLASS);
  }

  /* Outside click. The root's own handler has already run by the time this fires,
     so a click on a badge is skipped here rather than instantly re-closing it. */
  document.addEventListener('click', function (event) {
    Array.prototype.forEach.call(openHotspots(), function (hotspot) {
      if (!hotspot.contains(event.target)) close(hotspot);
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' && event.key !== 'Esc') return;

    var opened = openHotspots();
    if (!opened.length) return;

    /* Escape belongs to the instance the user is actually in: close that one and
       hand focus back to its own badge. Only fall back to closing every instance
       when focus sits outside all of them. */
    var activeRoot = document.activeElement ? ancestor(document.activeElement, ROOT_SELECTOR) : null;
    var scoped = activeRoot
      ? Array.prototype.filter.call(opened, function (hotspot) {
          return activeRoot.contains(hotspot);
        })
      : [];
    var targets = scoped.length ? scoped : opened;
    var focusTarget = scoped.length ? badgeOf(scoped[scoped.length - 1]) : null;

    Array.prototype.forEach.call(targets, close);
    if (focusTarget) focusTarget.focus();
  });

  /* A resize changes both the media box and the badge positions, so an open
     tooltip is re-measured instead of being left flipped the wrong way. */
  window.addEventListener('resize', function () {
    Array.prototype.forEach.call(openHotspots(), function (hotspot) {
      var root = hotspot.closest(ROOT_SELECTOR);
      if (!root) return;
      /* Refit first: the ResizeObserver runs later, and the stage still has the previous width's size. */
      fit(root);
      place(root, hotspot);
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroy(event.target);
  });

  /* Theme editor only: reveal the hotspot the merchant just selected. */
  document.addEventListener('shopify:block:select', function (event) {
    var hotspot = ancestor(event.target, HOTSPOT_SELECTOR);
    if (!hotspot) return;

    var root = hotspot.closest(ROOT_SELECTOR);
    if (root) open(root, hotspot);
  });

  document.addEventListener('shopify:block:deselect', function (event) {
    var hotspot = ancestor(event.target, HOTSPOT_SELECTOR);
    if (hotspot) close(hotspot);
  });
})();
